module.exports = __webpack_public_path__ + "static/media/MyListLabelRemoveButton.8ad2c02a.svg";